import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // If fallback is a React element, render it
      if (this.props.fallback) {
        return this.props.fallback;
      }
      // Or if fallback is a function, call it with error info
      if (typeof this.props.fallbackRender === "function") {
        return this.props.fallbackRender();
      }
      return <div>Something went wrong.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;